// ~/compta-app/client/src/components/Accueil/Articles/ArticleDetail.jsx
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { newsArticles } from './index';

const ArticleDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  // Trouve l'article correspondant au slug
  const article = newsArticles.find(
    (article) => article.link.includes(slug)
  );

  if (!article) {
    return <div>Article non trouvé</div>;
  }

  // Trouve l'index de l'article actuel
  const currentIndex = newsArticles.findIndex(
    (article) => article.link.includes(slug)
  );

  // Trouve l'article suivant
  const nextArticle = newsArticles[(currentIndex + 1) % newsArticles.length];

  return (
    <div className="article-detail">
      <h1>{article.title}</h1>
      <p className="article-category">{article.category}</p>
      <p className="article-date">{article.date}</p>
      <p className="article-highlight"><strong>{article.highlight}</strong></p>
      <p className="article-text">{article.text}</p>

      {/* Boutons de navigation */}
      <div className="article-navigation">
        <button
          onClick={() => navigate('/accueil')}
          className="return-home-button"
        >
          Retour à l'accueil
        </button>
        <button
          onClick={() => navigate(nextArticle.link)}
          className="next-article-button"
        >
          Article suivant
        </button>
      </div>
    </div>
  );
};

export default ArticleDetail;
